'use client';

/**
 * Drapeau tunisien animé (ondulation "au vent") — affiché à côté du logo UTSS.
 * SVG officiel : champ rouge, disque blanc, croissant + étoile rouges.
 * Animation 100% CSS (styled-jsx), légère et performante.
 */
export default function TunisianFlag({className = ''}: {className?: string}) {
  return (
    <span className={`tn-flag inline-block align-middle ${className}`} aria-label="Drapeau de la Tunisie" role="img">
      <svg viewBox="0 0 60 40" width="36" height="24" xmlns="http://www.w3.org/2000/svg" className="tn-flag__svg">
        <rect width="60" height="40" fill="#E70013" rx="2" />
        <circle cx="30" cy="20" r="10" fill="#fff" />
        <circle cx="31.5" cy="20" r="7" fill="#E70013" />
        <circle cx="34" cy="20" r="6" fill="#fff" />
        <path
          fill="#E70013"
          d="M31.7 20 L35.6 18.7 L33.2 22 L33.2 17.9 L35.6 21.3 Z"
        />
      </svg>
      <style jsx>{`
        .tn-flag {
          transform-origin: left center;
          animation: tn-wave 2.6s ease-in-out infinite;
          filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.18));
          will-change: transform;
        }
        .tn-flag__svg {
          display: block;
        }
        @keyframes tn-wave {
          0% {
            transform: perspective(120px) rotateY(0deg) skewY(0deg);
          }
          25% {
            transform: perspective(120px) rotateY(-12deg) skewY(1.5deg);
          }
          50% {
            transform: perspective(120px) rotateY(0deg) skewY(0deg);
          }
          75% {
            transform: perspective(120px) rotateY(12deg) skewY(-1.5deg);
          }
          100% {
            transform: perspective(120px) rotateY(0deg) skewY(0deg);
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .tn-flag {
            animation: none;
          }
        }
      `}</style>
    </span>
  );
}
